export function errorHandler(msg, url, line, col, error) {
    // Note that col & error are new to the HTML 5 spec and may not be 
    // supported in every browser.  It worked for me in Chrome.
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    var type;
    if (typeof error === "undefined" || error === null) {
        type = undefined;
    } else {
        type = typeof error.constructor === "undefined" ? undefined : error.constructor.name;
    }
    var payload = {
        'OccurredOn': new Date().toISOString(),
        'Details': {
            'Error': {
                'Message': msg,
                'Exception': JSON.stringify(error),
                'Type': type,
                'Source': url,
                'Line': line,
                'Col': col
            },
            'Environment': {
                'UtcOffset': new Date().getTimezoneOffset() / -60.0,
                'UserLanguage': navigator.userLanguage,
                'DocumentMode': document.documentMode,
                'BrowserWidth': w,
                'BrowserHeight': h,
                'ScreenWidth': screen.width,
                'ScreenHeight': screen.height,
                'ColorDepth': screen.colorDepth,
                'Browser': navigator.appCodeName,
                'BrowserName': navigator.appName,
                'BrowserVersion': navigator.appVersion,
                'Platform': navigator.platform
            },
            'Request': {
                'Url': [location.protocol, '//', location.host, location.pathname, location.hash].join(''),
                'Headers': {
                    'User-Agent': navigator.userAgent,
                    'Referer': document.referrer,
                    'Host': document.domain
                }
            },
            'Client': {
                'LayoutVersion': window.unify.version || 'Not supplied'
            }
        }
    };

    var req = new XMLHttpRequest();
    var params = JSON.stringify(payload);
    req.open("POST", "/unify/client/reporterror");
    req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    req.send(params);

    // If you return true, then error alerts (like in older versions of 
    // Internet Explorer) will be suppressed.
    //return true;
};